<div style="width: 100%;text-align: center;">
  <div style="display:flex;justify-content: center;align-items: center"><mat-spinner></mat-spinner></div><br>
  <p>Probíhá ověřování</p>
</div>
